import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { truncate } from "lodash";

type StaffTaskTitleProps = {
  title: string;
  maxLength?: number;
  isCancelled?: boolean;
  isComplete: boolean;
  onClick?: () => void;
  sx?: SxProps;
};

export default function StaffTaskTitle({
  title,
  isComplete,
  isCancelled,
  maxLength = 100,
  onClick,
  sx,
}: StaffTaskTitleProps) {
  const displayTitle = !maxLength
    ? title
    : truncate(title, { length: maxLength, omission: "…" });

  return (
    <Tooltip title={title} disableInteractive>
      <Box
        sx={{
          mt: 1,
          color: isComplete ? grey[700] : undefined,
          cursor: onClick ? "pointer" : undefined,
          "&:hover": {
            textDecoration: onClick ? "underline" : undefined,
          },
          ...sx,
        }}
        onClick={onClick}
      >
        <Typography
          variant="body3"
          sx={{ textDecoration: isCancelled ? "line-through" : undefined }}
        >
          {displayTitle}
        </Typography>
      </Box>
    </Tooltip>
  );
}
